import { useSelector } from 'react-redux'
import { getCoords } from '../Store'
import { useFeature } from '@core/Utils/hooks'
import { FeatureFlags } from '@mobi/settings/featureFlags'

function isNumberInList(list: string, target?: number): boolean {
  if (!list || !target) return false
  return list
    .split(',')
    .map(item => item.trim())
    .filter(item => item !== '')
    .map(item => Number(item))
    .filter(num => !isNaN(num))
    .some(num => num === target)
}

export const useIsVenueModeActive = (): boolean => {
  const { closestVenue } = useSelector(getCoords)
  const isVenueModeActive = useFeature(FeatureFlags.VENUE_MODE.key)
  const activeVenueModeVenues = useFeature(FeatureFlags.VENUE_MODE_AGENCIES.key)
  const isInsideVenue = !!closestVenue?.inside

  return (
    isVenueModeActive && 
    (isInsideVenue && isNumberInList(activeVenueModeVenues, closestVenue?.locationId) ||
      activeVenueModeVenues.includes('*'))
  )
}
